
import React from "react";
import { Badge } from "@/components/ui/badge";

interface CourseImageBlockProps {
  image_url?: string;
  title?: string;
  price?: number;
  currency?: string;
}

const CourseImageBlock = ({
  image_url,
  title = "",
  price,
  currency = "EUR",
}: CourseImageBlockProps) => (
  <div className="w-full md:w-2/5 rounded-lg overflow-hidden shadow-lg border border-kaija-sage bg-white relative">
    {image_url ? (
      <img 
        src={image_url} 
        alt={title} 
        className="w-full h-64 object-cover transition-transform duration-500 hover:scale-105"
        loading="lazy"
      />
    ) : (
      <div className="w-full h-64 bg-kaija-light flex items-center justify-center text-gray-300">
        No image
      </div>
    )}
    <Badge className="absolute top-4 left-4 bg-kaija-accent text-white shadow-lg px-4 py-2 text-lg">
      {price}&nbsp;{currency}
    </Badge>
  </div>
);

export default CourseImageBlock;
